var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShareLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 33.587 33.587",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#6a6a6a",
    strokeWidth: 1.3
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-135 15.52 13.246)",
    fill: "rgba(255,255,255,0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.111,
    cy: 11.639,
    rx: 12.111,
    ry: 11.639,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.111,
    cy: 11.639,
    rx: 11.461,
    ry: 10.989,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m11.344 22.243 10.01-10.01M21.169 19.879v-7.83M13.775 12.484h7.83"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareLink);
export default __webpack_public_path__ + "static/media/share_link.bb41c0b814dd4a358ae83985229fed43.svg";
export { ForwardRef as ReactComponent };